import { useEffect, useRef, useState } from "react";
import { Toaster } from "react-hot-toast";
import { connect } from "react-redux";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";

import { resetSession } from "@/redux/auth";
import {
  getSchedulingNotificationCountAction,
  postSchedulingNotificationClearAction,
  resetNotificationCount,
  resetNotificationError,
  resetNotificationStatusCode,
  resetNotificationSuccess,
  resetScheduleNotificationCount,
  resetScheduleNotificationList,
  resetScheduleNotificationListCount,
} from "@/redux/notification";
import type { RootState } from "@/redux/rootReducers";

import SchedulingNotification from "@/screens/Notification/SchedulingNotification/index";

import { ErrorSuccessModal } from "@/components/commons";

import type {
  GetSchedulingNotificationCountPayloadType,
  postSchedulingNotificationClearPayloadType,
} from "@/commonTypes/notificationType";

import {
  CloseIcon,
  NotificationGreyIcon,
  NotificationRedIcon,
} from "@/assets/images";

import "./scrollbar.scss";

type AppProps = {
  token: null | string;
  success: number | null;
  statusCode: number | null;
  error: string | null | undefined;
  // notificationCount: any;
  notificationCount: number;
  scheduleNotificationListCount: number;
  dispatchResetSession: () => void;
  dispatchResetError: () => void;
  dispatchResetNotificationStatusCode: () => void;
  dispatchResetNotificationSuccess: () => void;
  dispatchResetScheduleNotificationCount: () => void;
  dispatchPostSchedulingNotificationClearAction: (
    data: postSchedulingNotificationClearPayloadType
  ) => void;
  dispatchGetSchedulingNotificationCountAction: (
    data: GetSchedulingNotificationCountPayloadType
  ) => void;
  dispatchResetNotificationCount: () => void;
  dispatchResetScheduleNotificationList: () => void;
  dispatchResetScheduleNotificationListCount: () => void;
};
const Notification = ({
  token,
  success,
  statusCode,
  error,
  notificationCount,
  scheduleNotificationListCount,
  // notificationCount,
  dispatchResetSession,
  dispatchResetError,
  dispatchResetNotificationStatusCode,
  dispatchResetNotificationSuccess,
  dispatchResetScheduleNotificationCount,
  dispatchPostSchedulingNotificationClearAction,
  dispatchGetSchedulingNotificationCountAction,
  dispatchResetNotificationCount,
  dispatchResetScheduleNotificationList,
  dispatchResetScheduleNotificationListCount,
}: AppProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [notificationDivWidth, setNotificationDivWidth] =
    useState<boolean>(false);
  const notificationMountedRef = useRef<boolean>(true);
  const [markAllLoading, setMarkAllLoading] = useState(false);
  useEffect(() => {
    dispatchResetError();
    dispatchResetNotificationSuccess();
    dispatchResetNotificationStatusCode();
    // dispatchResetScheduleNotificationCount()
    const finalData = {
      token,
    };
    // dispatchGetSchedulingNotificationCountAction(finalData);
  }, []);

  useEffect(() => {
    if (!notificationMountedRef.current && notificationCount > 0) {
      // showNotification();
    } else {
      notificationMountedRef.current = false;
    }
  }, [notificationCount]);

  useEffect(() => {
    if (notificationCount) {
      setNotificationDivWidth(true);
    }
    setTimeout(() => {
      setNotificationDivWidth(false);
    }, 3000);
  }, [notificationCount]);

  // useEffect(() => {
  //   let delayDebounceFn: any = null;
  //   if (!error) {
  //     delayDebounceFn = setTimeout(() => {
  //       fetchNotificationCountData();
  //     }, 30000);
  //   }

  //   return () => clearTimeout(delayDebounceFn);
  // });

  const showNotification = () => {
    if ((window as any).Notification.permission === "granted") {
      new (window as any).Notification("Hello", {
        body: "You got new scheduling Notification",
      });
    } else if ((window as any).Notification.permission !== "denied") {
      (window as any).Notification.requestPermission().then(
        (permission: NotificationPermission) => {
          if (permission === "granted") {
            new (window as any).Notification("Hello", {
              body: "You got new scheduling Notification",
            });
          }
        }
      );
    }
  };

  const handleClearAll = () => {
    const payload: postSchedulingNotificationClearPayloadType = {
      token,
      params: {
        platform: "web",
        clear_all: true,
      },
    };
    dispatchPostSchedulingNotificationClearAction(payload);
  };

  const handleMarkAllRead = () => {
    if (markAllLoading) return;
    setMarkAllLoading(true);
    const payload: postSchedulingNotificationClearPayloadType = {
      token,
      params: {
        platform: "web",
        mark_as_all_read: true,
      },
    };
    dispatchPostSchedulingNotificationClearAction(payload);
  };
  useEffect(() => {
    if (isOpen === false) {
      setMarkAllLoading(false);
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen === true && success !== 0) {
      dispatchResetNotificationCount();
    }
  }, [isOpen, success]);

  const handleErrorModal = () => {
    if (success === 0) {
      if (!!error && !error.includes("Network Error") && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetError();
            }}
          />
        );
      } else {
        dispatchResetError();
      }
    }
  };

  const fetchNotificationCountData = () => {
    dispatchResetError();
    dispatchResetNotificationSuccess();
    dispatchResetNotificationStatusCode();
    dispatchResetNotificationStatusCode();
    const finalData = {
      token,
    };
    dispatchGetSchedulingNotificationCountAction(finalData);
  };

  return (
    <>
      <ButtonDropdown
        isOpen={isOpen}
        toggle={() => {
          setIsOpen(!isOpen);
        }}
      >
        <DropdownToggle
          style={{
            backgroundColor: "white",
            padding: "6px",
            position: "relative",
            marginRight: "10px",
          }}
        >
          <img src={isOpen ? NotificationRedIcon : NotificationGreyIcon} />
          {notificationCount > 0 && (
            <span
              className={
                notificationCount < 100
                  ? "notification-count"
                  : "notification-counts"
              }
            >
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {notificationCount > 0 ? notificationCount : ""}
              </span>
            </span>
          )}
        </DropdownToggle>
        <DropdownMenu right>
          <div
            className="thinScroll"
            style={{ width: "520px", padding: "16px 24px" }}
          >
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5
                className="text-start m-0"
                style={{ fontSize: "24px" }}
              >
                Notifications
              </h5>

              {scheduleNotificationListCount > 0 ? (
                <div className="d-flex align-items-center ">
                  <button
                    onClick={handleClearAll}
                    className="btn btn-outline-danger rounded-pill btn-sm mr-2"
                    style={{
                      height: "25px",
                      fontSize: "14px",
                      padding: "1px 16px",
                    }}
                  >
                    Clear All
                  </button>

                  <button
                    onClick={handleMarkAllRead}
                    disabled={markAllLoading}
                    className="btn btn-outline-danger rounded-pill btn-sm"
                    style={{
                      height: "25px",
                      fontSize: "14px",
                      padding: "1px 16px",
                    }}
                  >
                    Mark all as read
                  </button>
                </div>
              ) : (
                <span
                  onClick={() => {
                    setIsOpen(!isOpen);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={CloseIcon}
                    alt=""
                  />
                </span>
              )}
            </div>

            <hr style={{ marginTop: "0" }} />
            {isOpen && (
              <SchedulingNotification
                isOpen={isOpen}
                setIsOpens={setIsOpen}
              />
            )}
          </div>
        </DropdownMenu>
      </ButtonDropdown>
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.notification.fetching,
  success: state.notification.success,
  error: state.notification.error,
  statusCode: state.notification.statusCode,
  notificationCount: state.notification.notificationCount,
  scheduleNotificationListCount:
    state.notification.scheduleNotificationListCount,
  // notificationCount: state.notification.notificationCount,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetError: () => dispatch(resetNotificationError()),
  dispatchResetNotificationSuccess: () => dispatch(resetNotificationSuccess()),
  dispatchResetNotificationStatusCode: () =>
    dispatch(resetNotificationStatusCode()),
  dispatchResetScheduleNotificationCount: () =>
    dispatch(resetScheduleNotificationCount()),
  dispatchGetSchedulingNotificationCountAction: (
    data: GetSchedulingNotificationCountPayloadType
  ) => dispatch(getSchedulingNotificationCountAction(data)),
  dispatchResetNotificationCount: () => dispatch(resetNotificationCount()),
  dispatchPostSchedulingNotificationClearAction: (
    data: postSchedulingNotificationClearPayloadType
  ) => dispatch(postSchedulingNotificationClearAction(data)),
  dispatchResetScheduleNotificationList: () =>
    dispatch(resetScheduleNotificationList()),
  dispatchResetScheduleNotificationListCount: () =>
    dispatch(resetScheduleNotificationListCount()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Notification);
